import { Injectable } from "@angular/core";
import { WeekDays } from 'projects/Autofacets-Core/src/app/utils/enums';
import { BrandViewModelMultiSelector } from "../business-entities/brand-view-model-multiselector";
import { LogofSmsEmailSentDataService } from "../data-services/logof-sms-email-sent-data.service";
import { SmsLogRequestModel } from '../business-entities/smslog-request-model';
import { GenericResponse } from '../../../../Autofacets-Core/src/app/business-entities/generic-response.class';

@Injectable({
  providedIn: 'root'
})

export class LogofSmsEmailSentService {
  dealerId: string;
  competenceId: number;
  mechanicId: number;
  isEdit: boolean = false;
  brandList: BrandViewModelMultiSelector[];

  constructor(private service: LogofSmsEmailSentDataService) {
  }

  GetSMSLogList(smsLogRequestModel: SmsLogRequestModel): Promise<GenericResponse<any>> {
    return this.service.GetSMSLogList(smsLogRequestModel);
  }
  GetCommunicationList(model: any): Promise<GenericResponse<any>> {
    return this.service.GetCommunicationList(model);
  }

  getDayText(dayId: number): string {
    switch (dayId) {
      case WeekDays.Sunday:
        return 'Sunday';
      case WeekDays.Monday:
        return 'Monday';
      case WeekDays.Tuesday:
        return 'Tuesday';
      case WeekDays.Wednesday:
        return 'Wednesday';
      case WeekDays.Thursday:
        return 'Thursday';
      case WeekDays.Friday:
        return 'Friday';
      case WeekDays.Saturday:
        return 'Saturday';
      default:
        return '';
    }
  }
}